<template>
    <div>
      <br />
        <v-row v-bind:class="marginesy">
            <v-col cols="1"></v-col>
            <v-col cols="10">
                <p class="text-h4 text-center">DZIĘKUJEMY ZA ZAKUP!</p>
                <br />
                <p class="text-h5 text-center">Zapraszamy ponownie!</p>
            </v-col>
            <v-col cols="1"></v-col>
        </v-row>
        <v-row justify="center" class="mb-3">
          <v-col cols="3"></v-col>
          <v-col cols="6">
            <v-img
            src='../assets/thankyoupic.jpg'
            height="350"
            ></v-img>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
      return {
        mobile: false,
        marginesy: '',
      }
    },
    created() {
      this.mobile = this.$vuetify.display.mobile
      if(this.$vuetify.display.mobile == false){
        this.marginesy = "mt-16 mx-16 justify-center"
      }
    }
  } 
</script>